import { createContext, useContext, useState, FC, ReactNode } from "react";

import {
  IDataConfirmationAdministrators,
  IInstallmentsReceivedCombined,
  IFilterInstallmentsReceived,
  IDataConfirmationOperator,
  IDataConfirmationFiliais,
  IFilterProfitableValues,
  IContextDashboardBroker,
  IDataProfitableValues,
} from "./ContextDashboardBrokerTypes";
import {
  valuesDefaultFilterProfitableValues,
  valuesDefaultInstallmentsReceived,
} from "./ValuesDefaultContextProfile/ValuesDefaultContextDashboardBroker";

const ContextDashboardProvider = createContext({} as IContextDashboardBroker);

const ContextDashboardBrokerProviderContext: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [filterProfitableValues, setFilterProfitableValues] =
    useState<IFilterProfitableValues>(valuesDefaultFilterProfitableValues);

  const [filterInstallmentsReceived, setFilterInstallmentsReceived] =
    useState<IFilterInstallmentsReceived>(valuesDefaultInstallmentsReceived);

  const [dataProfitableValues, setDataProfitableValues] =
    useState<IDataProfitableValues>({ data: [{ label: "", value: 0 }] });

  const [dataInstallmentsReceivedCombined, setDataInstallmentsReceivedCombined,] =
    useState<IInstallmentsReceivedCombined>({
      data: [{ label: "", valueAll: 0, valuePrimary: 0 }],
      meta: { totalAll: 0, totalPrimary: 0 },
    });

  const [dataConfirmationFiliais, setDataConfirmationFiliais] =
    useState<IDataConfirmationFiliais>({ data: [], meta: { total: "" } });

  const [dataConfirmationOperator, setDataConfirmationOperator] =
    useState<IDataConfirmationOperator>({ data: [], meta: { total: "" } });
  const [dataConfirmationAdministrators, setDataConfirmationAdministrators] =
    useState<IDataConfirmationAdministrators>({
      data: [],
      meta: { total: "" },
    });

  return (
    <ContextDashboardProvider.Provider
      value={{
        setDataInstallmentsReceivedCombined,
        dataInstallmentsReceivedCombined,
        setFilterInstallmentsReceived,
        setDataConfirmationOperator,
        dataConfirmationAdministrators,
        setDataConfirmationAdministrators,
        setDataConfirmationFiliais,
        filterInstallmentsReceived,
        dataConfirmationOperator,
        setFilterProfitableValues,
        dataConfirmationFiliais,
        setDataProfitableValues,
        filterProfitableValues,
        dataProfitableValues,
      }}
    >
      {children}
    </ContextDashboardProvider.Provider>
  );
};

const useContextDashboardBrokerContext = (): IContextDashboardBroker =>
  useContext(ContextDashboardProvider);

export {
  useContextDashboardBrokerContext,
  ContextDashboardBrokerProviderContext,
};
